<template>
  <div class="cache-bar-wrap" v-if="visible">
    <div
      class="cache-bar"
      v-for="(range, index) in ranges"
      :key="`range-${index}`"
      :style="calcStyle(range)"
      @click.prevent.stop.self="handleClick($event, range)"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  inject: ['root'],
  computed: {
    min() {
      return this.root.min;
    },
    max() {
      return this.root.max;
    },
    dvalue() {
      return this.root.dvalue;
    },
    ranges() {
      return this.root.cacheRanges;
    },
    rootWidth() {
      return this.root.width;
    }
  },
  methods: {
    /**
     * @param {Event} event
     */
    handleClick(event, range) {
      let { offsetX } = event;
      let left = range[0] - this.min;
      offsetX = offsetX + (left / this.dvalue) * this.rootWidth;
      this.$emit('jumpto', { offsetX });
    },
    calcStyle(range) {
      let [min, max] = range;
      const _dvalue = max - min;
      min = min - this.min;
      return {
        width: `${this.calcPercent(_dvalue)}%`,
        left: `${this.calcPercent(min)}%`
      };
    },
    calcPercent(val) {
      return (val / this.dvalue) * 100;
    }
  }
};
</script>

<style lang="scss" scoped>
.cache-bar-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 2;
  border-radius: 8px;
  overflow: hidden;
  .cache-bar {
    height: 100%;
    position: absolute;
    background: #c7c1cc;
    cursor: pointer;
  }
}
</style>
